export default [
    {
        path: "/pms",
        name: "pms__root__",
        redirect: {
            name: "pms-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "pms",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "pms-index",
                component: () => import("@/views/pms/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/pms/fsf",
        name: "pms-fsf",
        meta: {
            title: "期权助手",
            icon: "fsf",
            parent: "pms",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/pms/fsf/calendar",
        children: [
            {
                path: "calendar",
                name: "pms-fsf-calendar",
                component: () => import("@/views/pms/fsf/calendar.vue"),
                meta: {
                    title: "日历管理",
                    icon: "calendar",
                },
            },
            {
                path: "auto-task",
                name: "pms-fsf-auto-task",
                component: () => import("@/views/pms/fsf/auto-task.vue"),
                meta: {
                    title: "采集任务",
                    icon: "spider",
                },
            },
            {
                path: "auto-task-history",
                name: "pms-fsf-auto-task-history",
                component: () => import("@/views/pms/fsf/auto-task-history.vue"),
                meta: {
                    title: "任务历史",
                    sidebarTitle: "任务记录",
                    icon: "history",
                },
            },
            {
                path: "menu",
                name: "pms-fsf-menu",
                component: () => import("@/views/omp/conf/menu.vue"),
                meta: {
                    title: "菜单管理",
                    icon: "menu",
                    app: "fsf",
                    permission: "manage_common_menu",
                },
            },
            {
                path: "document",
                name: "cms-document-fsf",
                component: () => import("@/views/cms/document/index.vue"),
                meta: {
                    title: "期权文档",
                    icon: "document",
                    app: "fsf",
                    detailRouteName: "cms-document-fsf-detail",
                    permission: "manage_common_document",
                },
            },
            {
                path: "document/detail/:id(\\d+)?",
                name: "cms-document-fsf-detail",
                hidden: true,
                component: () => import("@/views/cms/document/document-form.vue"),
                meta: {
                    title: "文档详情",
                    icon: "document",
                    affix: false,
                    app: "fsf",
                    activeMenu: "/pms/fsf/document",
                    permission: "manage_common_document",
                },
            },
        ],
    },
];
